module.exports = __webpack_public_path__ + "img/pro_one_8.fdea1ceb.jpg";